import React from "react";

import { SmallQuantityTicket } from "../../interface/api/SmallQuantityTicket";
import smallQuantityTicketService from "../../services/smallQuantityTicketService";
import SubStreamDriverForm from "../shared/sub-stream-driver-form";
import SmallQuantityPrintableTicket from "./small-quantity-printable-ticket";

const SmallQuantityDriverForm = () => (
  <SubStreamDriverForm<SmallQuantityTicket>
    service={smallQuantityTicketService}
    contractorFilter="isSmallQuantity"
    heading="SMALL QUANTITIES"
    backgroundColor="#e3f2fd"
    streamRoute="small-quantity"
    requireHaulRecordFields
    PrintableTicket={SmallQuantityPrintableTicket}
  />
);

export default SmallQuantityDriverForm;
